import React from "react";
import { Block } from "kanopi-components/Block";
import { Button, KIND, SHAPE, SIZE } from "kanopi-components/Button";
import { expandPadding } from "kanopi-components/utils/styles";
import { ParagraphSmall } from "kanopi-components/typography";
import { useStyletron } from "kanopi-components/theme/useStyletron";

type TBanner = {
  message: string;
  messageColor: string;
  hideButton?: boolean;
  buttonText?: string;
  onButtonClick?: () => void;
};
export const Banner = (props: TBanner) => {
  const [, theme] = useStyletron();
  const {
    message,
    messageColor = theme.colors.contentInversePrimary,
    hideButton = false,
    buttonText,
    onButtonClick = () => undefined,
    ...restProps
  } = props;

  return (
    <Block
      width="100%"
      backgroundColor={theme.colors.backgroundNegative}
      overrides={{
        Block: {
          style: {
            zIndex: theme.zIndex.fixedComponent,
          },
        },
      }}
      {...restProps}
    >
      <Block
        display="flex"
        flexDirection={["column", "column", "row"]}
        justifyContent={["space-around", "space-around", "space-between"]}
        alignItems={["flex-start", "flex-start", "center"]}
        {...expandPadding(theme.sizing.scale600)}
      >
        <ParagraphSmall color={messageColor} margin={0}>
          {message}
        </ParagraphSmall>
        {!hideButton && (
          <Button
            kind={KIND.secondary}
            shape={SHAPE.pill}
            size={SIZE.mini}
            NORMAL_WIDTH_RESET
            overrides={{
              BaseButton: {
                style: {
                  textTransform: "uppercase",
                },
              },
            }}
            onClick={onButtonClick}
            data-testid="bannerButton"
          >
            {buttonText}
          </Button>
        )}
      </Block>
    </Block>
  );
};
